import { ChangeDetectionStrategy, Component, input, model, output } from '@angular/core';
import {
  NgbDropdown,
  NgbDropdownButtonItem,
  NgbDropdownItem,
  NgbDropdownMenu,
  NgbDropdownToggle,
  PlacementArray,
} from '@ng-bootstrap/ng-bootstrap';
import { NgClass, TitleCasePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

type BtnSize = 'sm' | 'md' | 'lg' | 'xl';

@Component({
  selector: 'mwe-button-dropdown',
  templateUrl: './button-dropdown.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgbDropdown, NgbDropdownToggle, NgClass, NgbDropdownMenu, NgbDropdownButtonItem, NgbDropdownItem, TitleCasePipe, TranslatePipe],
})
export class ButtonDropdownComponent {
  placement = input<PlacementArray>('bottom-right');
  buttonSize = input<`btn-${BtnSize}`>('btn-md');
  buttonColor = input<'btn-primary--dark-blue' | 'btn-warning'>('btn-primary--dark-blue');
  title = input.required<string>();
  disabled = input<boolean>(false);
  options = input.required<string[]>();
  testAttribute = input<string>('mwe-button-dropdown');
  prefix = input<string>();
  readonly currentValueChange = output<string>();

  currentValue = model.required<string>();

  selectDropdown(dropdownMenuItem: string) {
    this.currentValue.set(dropdownMenuItem);
    this.currentValueChange.emit(dropdownMenuItem);
  }

  isOptionSelected(dropdownMenuItem: string) {
    return dropdownMenuItem === this.currentValue();
  }
}
